import { render, staticRenderFns } from "./addOwner.vue?vue&type=template&id=627427b0&scoped=true"
import script from "./addOwner.vue?vue&type=script&lang=js"
export * from "./addOwner.vue?vue&type=script&lang=js"
import style0 from "./addOwner.vue?vue&type=style&index=0&id=627427b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627427b0",
  null
  
)

export default component.exports